<!-- 评分 星星 -->
<template> 
  <span class="rank">
    <span class="rank_stars">
      <img src="./images/combined_stars.png">
      <img class="large" src="./images/combined_stars_large.png">
      <i :style="'width: '+lengthOfStars(point)"></i>
    </span>
    <b>{{point}}</b> 
  </span>
</template>

 
<script>
  export default {
    name:"rank-stars",
    props:["point"],
    methods: {
      lengthOfStars: function(num) {
        var num = num || ''
        typeof(num) == 'number' ? num: num = parseInt(num)
        return num * 10 + "%"
      }
    }
  }
</script>

<style scoped>
.rank {
  vertical-align: middle;
  height:21px;
  font-size:5px;
}
.rank .rank_stars {
  width: 62px;
  height: 10px;
  display: inline-block;
  position: relative;
  background-color: #f2f2f2;
  text-align: left;
      margin: 13px 5px 0 0;
  vertical-align: -4px;
  float:left;
}
.rank b {
  font-size:12px;
  color: #e37d28;
  line-height:17px;
}


.rank .rank_stars img {
  width: 100%;
  display: block;
  position: absolute;
  left: 0;
  z-index: 1;
}
.rank .rank_stars img.large {
  display: none;
}
.rank .rank_stars i {
  background-color: #ffbc42;
  vertical-align: top;
  height: 100%;
  display: inline-block;
}
.rank.large .rank_stars {
  width: 148px;
  height: 22px;
}
.rank.large .rank_stars img {
  display: none;
}
.rank.large .rank_stars img.large {
  display: block;
}
.rank.large b {
  display: none;
  color: #e37d28;
}

</style>



// WEBPACK FOOTER //
// src/components/Content/RankStars.vue